import React from 'react';
import PropTypes from 'prop-types';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { DarkModeSwitch } from '@components/Inputs';

function SettingsListItem({
    themeMode,
    handleThemeChange,
    menuOpen
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon sx={{ color: '#fff', minWidth: '48px' }}>
                    <SettingsIcon />
                </ListItemIcon>
                <ListItemText
                    primaryTypographyProps={{
                        variant: 'body1',
                        sx: { fontSize: '0.95rem' }
                    }}
                    style={{ fontWeight: 'bold' }}
                    primary={'Settings'}
                />
            </ListItemButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        minWidth: '27em',
                        background: (theme) => theme.palette.navbar.backgroundHover,
                        mt: 1.5,
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 15,
                            left: -5,
                            width: 10,
                            height: 10,
                            background: (theme) => theme.palette.navbar.backgroundHover,
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: menuOpen ? 272 : 63
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}>
                <List>
                    <ListItem>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}>
                            <Typography sx={{ color: (theme) => theme.palette.navbar.color }}>
                                Mode
                            </Typography>
                            <DarkModeSwitch
                                checked={themeMode === 'light'}
                                handleChange={handleThemeChange}
                            />
                        </Box>
                    </ListItem>
                </List>
            </Menu>
        </>
    );
}

SettingsListItem.propTypes = {
    themeMode: PropTypes.string,
    handleThemeChange: PropTypes.func.isRequired,
    menuOpen: PropTypes.bool.isRequired
};

export default SettingsListItem;
